import { useEffect, useState } from "react";

interface InstallPrompt {
  showPrompt: boolean;
  promptToInstall: () => void;
  dismissPrompt: () => void;
}

/**
 * Custom hook to handle PWA install prompt
 * @returns {InstallPrompt} - Returns state for showing the prompt and a function to trigger installation
 */
const useInstallPrompt = (): InstallPrompt => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showPrompt, setShowPrompt] = useState(false);
    console.log("HANDLE: ", deferredPrompt);
  useEffect(() => {
    const handleBeforeInstallPrompt = (event: any) => {
      event.preventDefault(); // Prevent auto-showing of the default install prompt
      setDeferredPrompt(event);
      setShowPrompt(true); // Show our custom prompt
    };

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone;

    if (!isStandalone) {
      window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const promptToInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Show the browser install prompt

      deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null);
        setShowPrompt(false); // Hide the prompt after interaction
      });
    }
  };

  const dismissPrompt = () => setShowPrompt(false);

  return { showPrompt, promptToInstall, dismissPrompt };
};

export default useInstallPrompt;
